import { createActionGroup, props } from "@ngrx/store";
import { SalesCreditRoleDto } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataSalesCreditRolesActions = createActionGroup({
    source: "Data / Sales Credit Roles",
    events: {
        "Load": props<{ companyId: string; languageCode: string }>(),
        "Load Success": props<{ salesCreditRoles: SalesCreditRoleDto[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
